import { apiClient } from './api';
import type {
  AdminFinancialHealthDTO,
  CourierWalletSummaryDTO,
  HighRiskCourierDTO,
  LedgerTransactionDTO,
  RestaurantFinanceSummaryDTO,
} from '@/types';

export const financeService = {
  async getCourierWalletSummary(): Promise<CourierWalletSummaryDTO> {
    const response = await apiClient.get<CourierWalletSummaryDTO>('/finance/courier/wallet');
    return response.data.data;
  },

  async getCourierLedger(): Promise<{ transactions: LedgerTransactionDTO[] }> {
    const response = await apiClient.get<{ transactions: LedgerTransactionDTO[] }>(
      '/finance/courier/ledger',
    );
    return response.data.data;
  },

  async getRestaurantFinanceSummary(): Promise<RestaurantFinanceSummaryDTO> {
    const response = await apiClient.get<RestaurantFinanceSummaryDTO>(
      '/finance/restaurant/summary',
    );
    return response.data.data;
  },

  async getRestaurantLedger(): Promise<{ transactions: LedgerTransactionDTO[] }> {
    const response = await apiClient.get<{ transactions: LedgerTransactionDTO[] }>(
      '/finance/restaurant/ledger',
    );
    return response.data.data;
  },

  async getAdminFinancialHealth(): Promise<AdminFinancialHealthDTO> {
    const response = await apiClient.get<AdminFinancialHealthDTO>('/finance/admin/health');
    return response.data.data;
  },

  async getHighRiskCouriers(): Promise<{ couriers: HighRiskCourierDTO[] }> {
    const response = await apiClient.get<{ couriers: HighRiskCourierDTO[] }>(
      '/finance/admin/high-risk-couriers',
    );
    return response.data.data;
  },

  async submitCashPayment(amount: number, orderIds?: string[], notes?: string): Promise<{
    submittedAmount: string;
    closedDebts: number;
    remainingDebt: string;
    updatedPayments: number;
  }> {
    const response = await apiClient.post('/finance/courier/submit-cash', {
      amount,
      orderIds,
      notes,
    });
    return response.data.data;
  },

  async getPendingCashPaymentsForCourier(): Promise<{
    orders: Array<{
      orderId: string;
      orderNumber: string;
      totalAmount: number;
      debtAmount: string;
      createdAt: Date;
      deliveredAt: Date | null;
      daysSinceDelivery: number;
    }>;
    totalPendingAmount: string;
  }> {
    const response = await apiClient.get('/admin/finance/pending-cash-payments');
    return response.data.data;
  },
};

